import Vue from 'vue'
import Vuex from 'vuex'

import moduleCatalogo from './modules/moduleCatalogo'
import moduleItens from './modules/moduleItens'
import moduleCarrinho from './modules/moduleCarrinho'
import moduleEmpresa from './modules/moduleEmpresa'
import moduleCheckout from './modules/moduleCheckout'
import moduleIdPedido from './modules/moduleIdPedido'
import moduleCadastroProduto from './modules/moduleCadastroProduto'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		alert: {},
	},
	getters: {},
	mutations: {
		setAlert(state, alert) { state.alert = alert },
	},
	actions: {
		showError({ commit }, error) {
			let msg = ''
			if (typeof error === 'string') msg += error
			else if (error.response.data.detalhes) {
				msg += error.response.data.detalhes
			} else if (error.response.data.msg) {
				msg += error.response.data.msg
			} else {
				msg += error.message
			}
			commit('setAlert', { color: 'error', msg, visible: true })
		},
		showSuccess({ commit }, msg) {
			commit('setAlert', { color: 'success', msg, visible: true })
		},
	},
	modules: {
		moduleCatalogo,
		moduleItens,
		moduleCarrinho,
		moduleEmpresa,
		moduleCheckout,
		moduleIdPedido,
		moduleCadastroProduto
	}
})

export default store